<template>
   <div id="langCurrCountrySwitch-modal-wrapper">

     <div class="modal fade" ref="langCurrCountrySwitchModal" id="langCurrCountrySwitchModal" tabindex="-1" role="dialog">
       <div class="modal-dialog">
         <div class="modal-content" >
           <div class="modal-header" style="background:#475d7d">
             <div class="modal-title h3 w-100" style="color: white">
               {{ $translate("Servershop5::Template.CountryLangCurrencyPreferenceHeader") }}
             </div>

             <button type="button" class="close" style="color:white!important;margin:unset!important" data-dismiss="modal" aria-hidden="true" >&times;</button>
           </div>
           <div class="modal-body my-1">
             <div class="row my-2 h5">
               <div class="col-lg col-12 my-1">
                 <label for="currencySelect">{{ $translate("Servershop5::Template.switchCurrency") }}</label>
                 <select id="currencySelect" class="selectLangCurrCountry" v-model="selectedCurrency">
                   <option
                       v-for="currency in filteredCurrencies"
                       :key="currency.name"
                       :value="currency.name"
                   >
                     {{ currency.name }} ({{ currency.symbol }})
                   </option>
                 </select>
               </div>
               <div class="col-lg col-12 my-1">
                 <label for="languageSelect">{{ $translate("Servershop5::Template.switchLanguage") }}</label>
                 <select id="languageSelect" class="selectLangCurrCountry" v-model="selectedLanguage">
                   <option value="de">DE</option>
                   <option value="en">EN</option>
                 </select>
               </div>
               <template v-if="isLoggedIn">

               </template>
               <template v-else>
                 <shipping-country-select-custom
                     @updateShippingCountryId="setSelectedShippingCountry"
                     class="col-lg col-12 my-1"
                 >
                 </shipping-country-select-custom>
               </template>
             </div>

             <div class="row my-4">
               <div class="col-12" id="content">
                  <template v-if="selectedCurrency == 'EUR' && selectedShippingCountry == 4">
                    <template v-if="selectedLanguage == 'de'" >
                      Grüezi, Kunden aus der Schweiz! Wenn Sie die Währung CHF auswählen, erhalten Sie die Zahlungsmöglichkeit auf ein Schweizer PostFinance Konto oder via Twint sowie nach dem Kauf Ihre Rechnung ausgestellt in CHF.
                    </template>
                    <template v-else>
                      Grüezi, customers from Switzerland! If you select CHF as your currency, you'll have the option to pay via a Swiss PostFinance account or Twint, and your invoice will be issued in CHF after the purchase.
                    </template>
                  </template>
                 <template v-if="selectedShippingCountry == 12">
                   <template v-if="selectedLanguage == 'de'" >
                     Leider können wir Bestellungen nach Großbritannien erst ab einem Bestellwert von 200 EUR annehmen.
                   </template>
                   <template v-else>
                     Please note that we only accept orders to the UK starting from a minimum order value of 200 EUR.
                   </template>
                 </template>
               </div>
             </div>
             <div class="row mb-1 mt-4">
               <div class="col-6">
                 <button  class="btn btn-primary  btn-block" ref="close" data-dismiss="modal" >
                   {{ $translate("Servershop5::Template.cancelModal") }}
                 </button>
               </div>
               <div class="col-6">
                 <button  class="btn btn-block btn-primary" @click="update()">
                 {{ $translate("Servershop5::Template.updateShopSettings") }}
                 </button>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
</template>

<script>
import ApiService from "../services/ApiService";
export default {
  data() {
    return {
      selectedShippingCountry:1,
      selectedCurrency: 'EUR',  // Default selected currency
      selectedLanguage: 'de',   // Default selected language
      currencies: [
        { name: 'CHF', symbol: 'CHF' },
        { name: 'EUR', symbol: '€' },
        { name: 'GBP', symbol: '£' }
      ],
    };
  },
  props:
  {
    urls: {
      type: Object,
      default: () => {}
    }
  },
  mounted()
  {
    this.selectedShippingCountry = App?.initialData?.shippingCountryId ?? 1;
    this.selectedLanguage = App?.language ?? 'de';
    this.selectedCurrency = this.currencies.find(c => c.symbol == (App?.activeCurrency ?? '€'))?.name;

    const url = new URL(window.location.href);  // Or you can use a specific URL as a string
    const sCountryId = url.searchParams.get("setShippingCountry");
    if(sCountryId > 0)
    {
      this.setShippingCountry(sCountryId)
    }

  },
  computed: {
    isLoggedIn()
    {
      return (this.$store?.state?.user?.userData && this.$store?.state?.user?.userData.id > 0);
    },
    sCountries()
    {
      return App?.initialData?.shippingCountries ?? [];
    },
    currentCurrencySymbol() {
      const selected = this.currencies.find(currency => currency.name === this.selectedCurrency);
      return selected ? selected.symbol : '';
    },
    filteredCurrencies() {
      return this.currencies.filter(currency =>
          ['CHF', 'EUR', 'GBP'].includes(currency.name)
      );
    }
  },
  methods: {

    setSelectedShippingCountry(id) {
      // Update the shippingCountryId with the emitted ID
      this.selectedShippingCountry = id;
    },
    setShippingCountry( shippingCountryId)
    {

      if (shippingCountryId !== ceresStore.state.basket.data.shippingCountryId)
      {
        return new Promise((resolve, reject) =>
        {
          const oldShippingCountryId = ceresStore.state.basket.data.shippingCountryId;
          document.dispatchEvent(new CustomEvent("afterShippingCountryChanged", { detail: shippingCountryId }));
          ceresStore.state.basket.data.shippingCountryId = shippingCountryId;

          ApiService.post("/rest/io/shipping/country", { "shippingCountryId": shippingCountryId })
              .done(data =>
              {
                resolve(data);
              })
              .fail(error =>
              {
                document.dispatchEvent(new CustomEvent("afterShippingCountryChanged", { detail: oldShippingCountryId }));
                ceresStore.state.basket.data.shippingCountryId = oldShippingCountryId;
                reject(error);
              });
        });
      }

    },
    update()
    {
      let url = this.urls[this.selectedLanguage] ?? urls['x-default'];

      url+='?currency='+this.selectedCurrency+'&setShippingCountry='+this.selectedShippingCountry

      window.location.href = url;
    },
  }
};
</script>



